// PRODUCTION — admin flow editor
import React from 'react'
import tw from 'twin.macro'
import { FlowEditorErrorBoundary } from 'src/components/flow-editor/FlowEditorErrorBoundary'
import { FlowEditorErrorState } from 'src/components/flow-editor/FlowEditorErrorState'
import { FlowEditorSkeleton } from 'src/components/flow-editor/FlowEditorSkeleton'
import { FlowEditorHeader } from 'src/components/flow-editor/header/FlowEditorHeader'
import { FlowEditorMainLayout } from 'src/components/flow-editor/main/FlowEditorMainLayout'
import { FlowEditorAddStepModal } from 'src/components/flow-editor/modals/FlowEditorAddStepModal'
import { FlowEditorUnsavedModal } from 'src/components/flow-editor/modals/FlowEditorUnsavedModal'
import { FlowEditorProvider } from './context/FlowEditorProvider'
import { useFlowEditorContext } from './context/useFlowEditorContext'

const FlowEditorPageContent = () => {
  const { error, pageBlockingLoading, template } = useFlowEditorContext()

  if (pageBlockingLoading) {
    return <FlowEditorSkeleton />
  }

  if (error && !template) {
    return <FlowEditorErrorState message={error} />
  }

  if (!template) {
    return null
  }

  return (
    <div css={tw`h-full flex-1 overflow-hidden bg-shades-50`}>
      <div
        css={tw`mx-auto flex h-full min-h-0 w-full max-w-[1456px] flex-col gap-6 px-6 py-8 text-base font-normal leading-[22px] text-shades-900`}
      >
        <FlowEditorHeader />
        <FlowEditorMainLayout />
        <FlowEditorAddStepModal />
        <FlowEditorUnsavedModal />
      </div>
    </div>
  )
}

export const FlowEditorPage = () => (
  <FlowEditorErrorBoundary>
    <FlowEditorProvider>
      <FlowEditorPageContent />
    </FlowEditorProvider>
  </FlowEditorErrorBoundary>
)
